import axios from 'axios';
import router from '@/router';

// 创建 axios 实例
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL, // API的基础路径，从环境变量读取
    timeout: 2000, // 请求超时时间
});

// 添加请求拦截器
apiClient.interceptors.request.use(function (config) {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers['Authorization'] = token;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
apiClient.interceptors.response.use(function (response) {
    // 检查响应状态码
    const code = response.data?.code;
    
    // 处理嵌套的 code.code 结构
    const statusCode = code?.code || code;
    
    // 如果是 401 或 403，跳转到登录页
    if (statusCode === 401 || statusCode === 403) {
        // 清除本地存储的 token
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_info');
        
        // 跳转到登录页，记录当前 URL 以便登录后跳转回来
        if (router.currentRoute.value.path !== '/login') {
            const currentPath = router.currentRoute.value.fullPath || router.currentRoute.value.path;
            router.push({
                path: '/login',
                query: { redirect: currentPath }
            });
        }
        
        return Promise.reject(new Error('未授权，请重新登录'));
    }
    
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 处理 HTTP 错误状态码
    if (error.response) {
        const status = error.response.status;
        if (status === 401 || status === 403) {
            // 清除本地存储的 token
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_info');
            
            // 跳转到登录页，记录当前 URL 以便登录后跳转回来
            if (router.currentRoute.value.path !== '/login') {
                const currentPath = router.currentRoute.value.fullPath || router.currentRoute.value.path;
                router.push({
                    path: '/login',
                    query: { redirect: currentPath }
                });
            }
        }
    }
    
    // 对响应错误做点什么
    return Promise.reject(error);
});
export default apiClient;